var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.root, ( _obj = {}, _obj[_vm.$style.rootHigh] = _vm.value > 80, _obj )]},[_c('span',{class:_vm.$style.label},[_vm._v(_vm._s(_vm.label))]),_c('b',{class:[_vm.$style.bar, _vm.barValueClass]},[_c('span',{class:_vm.$style.value},[_vm._v(_vm._s(_vm.value)+"%")])])])
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56659bd7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/assets/js/objects/MeterBar/index.vue
// module id = VIcD
// module chunks = 2